import { CSSObject } from "@emotion/react";
import { Colors } from "../../../ui-library/design-tokens/colors";
import { Fonts } from "../../../ui-library/design-tokens/fonts";
import { grid } from "../../../ui-library/design-tokens/grid";
import { Device } from "../../../ui-library/design-tokens/media-queries";

const label: CSSObject = {
  fontSize: 12,
  fontWeight: Fonts.Weight.SemiBold,
  color: Colors.MidGrey,
  marginBottom: grid(0.5),
  [Device.DesktopTablet]: {
    fontSize: 14,
    marginBottom: grid(1),
  },
};

const button: CSSObject = {
  minWidth: grid(6),
  marginRight: grid(1),
  marginBottom: grid(1),
  [Device.DesktopTablet]: {
    marginRight: grid(1.5),
    marginBottom: grid(1.5),
  },
};

const styles = {
  label,
  button,
};

export default styles;
